import { useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import { useControlStore } from '@editor/stores'

/**
 * Hides the tensile transmitters of the given elements in the global tensile transmitter mesh
 * while mounted, e.g. while a form draws its own (unsaved) version of them instead
 */
const useHideTensileTransmitters = (elementGuids: string[] | string | null | undefined) => {
  const addHiddenTensileTransmitterElementIdGroup = useControlStore(
    state => state.addHiddenTensileTransmitterElementIdGroup,
  )
  const removeHiddenTensileTransmitterElementIdGroup = useControlStore(
    state => state.removeHiddenTensileTransmitterElementIdGroup,
  )

  useLayoutEffect(() => {
    if (!elementGuids || elementGuids.length === 0) return

    const actualElementGuids = Array.isArray(elementGuids) ? elementGuids : [elementGuids]

    const uuid = v4()

    addHiddenTensileTransmitterElementIdGroup(uuid, actualElementGuids)

    return () => {
      removeHiddenTensileTransmitterElementIdGroup(uuid)
    }
  }, [
    addHiddenTensileTransmitterElementIdGroup,
    removeHiddenTensileTransmitterElementIdGroup,
    elementGuids,
  ])
}

export default useHideTensileTransmitters
